var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-100 w-100 d-flex flex-column align-items-center"},[_c('div',{staticClass:"w-100"},[_c('NavBar'),_c('div',{staticClass:"main-bottom",staticStyle:{"display":"flex"}},[_c('SidebarTemplate'),_c('div',{staticClass:"homeRight flex-fill"},[_vm._t("default")],2)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }